if(typeof _XLSX === 'undefined') {var e = new Error("Cannot find module '_XLSX'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = _XLSX;